import { Component, OnInit } from '@angular/core';
import { ProgressManagerService, VersicherungsablaufStandardService } from '@vhv/tarifrechner-common';
import { AppConfiguration } from './app.configuration';
import { RateCyberService } from '../rate/rate-cyber.service';
import { DownloadCyberService } from '../service/download-cyber.service';


@Component({
    selector: 'vhv-app-root',
    templateUrl: './app.component.html',
    host: { 'class': 'app-root' },
})
export class AppComponent{

    constructor(
        private appConfig: AppConfiguration,
        private progressManagerService: ProgressManagerService,
        private rateCyberService: RateCyberService,
        private downloadService: DownloadCyberService,
        private versicherungsablaufService: VersicherungsablaufStandardService,
    ) {
    }

    onActivate(event:any) {
        window.scroll(0,0);
    }
}
